import {TableDefinition} from "../table/table-definition";
import {TableModel} from "../table/table-model";
import {ContentModel} from "./content-model";
import {ViewDefinition} from "../view/view-definition";
import {ViewModel} from "../view/view-model";
import {FormDisplayType} from "../type/form-display-type.enum";

/**
 * Helps to pretend having a details context
 * Used when executing workflow transitions, as this might require executing client code such as popping up required field modal form
 */
export class KanbanCardContentModel extends ContentModel {
  constructor(viewDefinitionOrModel: ViewDefinition | ViewModel, tableDefinitionOrModel: TableDefinition | TableModel, record: any) {
    super(viewDefinitionOrModel, tableDefinitionOrModel, record);
    this.viewModel.setFormDisplayType(FormDisplayType.FORM);
    this.viewModel.setParentContext('kanban');
    this.viewModel.setIsRecordSyncDisabled(true);
  }

  update(data: any, retainFieldValues?: boolean) {
    // noop
  }
}
